function concatenateBuffers(buffer1: ArrayBuffer, buffer2: ArrayBuffer): ArrayBuffer {
    const combinedBuffer = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    combinedBuffer.set(new Uint8Array(buffer1), 0);
    combinedBuffer.set(new Uint8Array(buffer2), buffer1.byteLength);
    return combinedBuffer.buffer;
}

async function digestFileInChunks(file: File, chunkSize: number): Promise<ArrayBuffer> {
    const reader = new FileReader();
    let offset = 0;
    let hash: ArrayBuffer | null = null;

    return new Promise<ArrayBuffer>((resolve, reject) => {
        const processChunk = async () => {
            function readChunkAsArrayBuffer(chunk: Blob): Promise<ArrayBuffer> {
                return new Promise<ArrayBuffer>((resolveChunk) => {
                    reader.onload = () => {
                        resolveChunk(reader.result as ArrayBuffer);
                    };

                    reader.readAsArrayBuffer(chunk);
                });
            }

            const start = offset;
            const end = Math.min(start + chunkSize, file.size);
            const chunk = file.slice(start, end);
            const chunkBuffer = await readChunkAsArrayBuffer(chunk);
            const subtle = global.crypto && global.crypto.subtle;

            if (!hash) {
                hash = await subtle.digest("SHA-256", chunkBuffer);
            } else {
                hash = await subtle.digest(
                    "SHA-256",
                    concatenateBuffers(hash, await subtle.digest("SHA-256", chunkBuffer))
                );
            }

            offset += chunkBuffer.byteLength;

            if (offset < file.size) {
                processChunk();
            } else {
                resolve(hash);
            }
        };

        reader.onerror = () => {
            reject(reader.error);
        };

        processChunk();
    });
}

export const getHash = async (file: any) => {
    const chunkSize = 500 * 1024 * 1024; // 500 MB chunks (adjust as needed)
    const hashBuffer = await digestFileInChunks(file, chunkSize);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join(""); // convert bytes to hex string
    return hashHex;
};